import gql from 'graphql-tag'

export default gql`
  fragment optimisticCartFragment on Cart {
    items {
      _id
      isOutOfStock
      outOfStockMessage
      amount
      realPrice: unitPrice(includeDiscount: false)
      unitPrice
      description
      descriptionItems {
        title
        selections
      }
      product {
        _id
        name
      }
    }
    storeId
    deliveryType
    deliveryFee
    menuId
    itemsPrice
    realPrice: itemsPrice(includeDiscount: false)
    totalPrice
    amountToPay
  }
`
